import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import './textAreaField.scss';
import { getFieldValue } from '../../../utils';
import { CharacterCount } from '../CharacterCount/characterCount';
import { NodeType } from '../../../enums/NodeType';

export const TextAreaField = (props: FieldProps) => {
  const { field, data, updater } = props;
  const { updateField, updateData } = updater;
  const value = getFieldValue(field, data);

  const handleBlur = (e: any) => {
    let cleanedValue = e.target.value;
    if (field.key == NodeType.Position + '.position') {
      cleanedValue = cleanedValue.trim().replace(/\n/g, ' ');
    }
    updateData(field, cleanedValue);
  };

  return (
    <FieldGroup
      {...props}
      value={value}
      componentRight={
        field?.key == `Item.summary` ? (
          <CharacterCount value={value} max={2000} />
        ) : !!field?.maxCharCount ? (
          <CharacterCount value={value} max={field.maxCharCount} />
        ) : null
      }
    >
      <textarea
        id="textArea"
        className="form-control form-control-sm"
        value={value}
        rows={3}
        onBlur={handleBlur}
        onChange={(e: any) => {
          updateField(field, e.target.value);
        }}
      />
    </FieldGroup>
  );
};
